const sampling_times = [
    {
        value : "9:00",
        title : "۹ صبح"
    },
    {
        value : "10:00",
        title : "۱۰ صبح"
    },
    {
        value : "11:00",
        title : "۱۱ صبح"
    },
    {
        value : "12:00",
        title : "۱۲ ظهر"
    },
    {
        value : "13:00",
        title : "۱ عصر"
    },
    {
        value : "14:00",
        title : "۲ عصر"
    },
    {
        value : "15:00",
        title : "۳ عصر"
    },
    {
        value : "16:00",
        title : "۴ عصر"
    },
    {
        value : "17:00",
        title : "۵ عصر"
    },
    {
        value : "18:00",
        title : "۶ عصر"
    },
    {
        value : "19:00",
        title : "۷ عصر"
    },
    {
        value : "20:00",
        title : "۸ عصر"
    },
    {
        value : "21:00",
        title : "۹ شب"
    },
    {
        value : "22:00",
        title : "۱۰ شب"
    },
    {
        value : "23:00",
        title : "۱۱ شب"
    }
];
const sampling_default_data  = {
    sampling_date : {
      key : 'sampling_date',
      value : '',
      title : 'تاریخ نمونه‌گیری'
    },
    sampling_from_hour : {
      key : 'sampling_from_hour',
      value : '',
      title : 'از ساعت'
    },
    sampling_to_hour : {
      key : 'sampling_to_hour',
      value : '',
      title : 'تا ساعت'
    },
    sampler_name : {
      key : 'sampler_name',
      value : '',
      title : 'نام نمونه‌گیر'
    },
    sampler_contact_phone: {
      key : 'sampler_contact_phone',
      value : '',
      title : 'تلفن هماهنگی نمونه‌گیر'
    },
    fasting: {
      key : 'fasting',
      value : false,
      title : 'ناشتایی'
    },
    sample_type: {
      key : 'sample_type',
      value : null,
      title : 'نوع نمونه'
    },
    result_date : {
      key : 'result_date',
      value : '',
      title : 'تاریخ تقریبی ارسال نتایج'
    },
    result_hour : {
      key : 'result_hour',
      value : '',
      title : 'ساعت تقریبی ارسال نتایج'
    },
};
const sampling_home_care_default_data  = {
  sampling_date : {
    key : 'sampling_date',
    value : '',
    title : 'تاریخ اعزام پزشک/پرستار'
  },
  sampling_from_hour : {
    key : 'sampling_from_hour',
    value : '',
    title : 'از ساعت'
  },
  sampling_to_hour : {
    key : 'sampling_to_hour',
    value : '',
    title : 'تا ساعت'
  },
  sampler_name : {
    key : 'sampler_name',
    value : '',
    title : 'نام پزشک/پرستار'
  },
  sampler_contact_phone: {
    key : 'sampler_contact_phone',
    value : '',
    title : 'تلفن هماهنگی پزشک/پرستار'
  },
};
export {
    sampling_times,
    sampling_default_data,
    sampling_home_care_default_data
}